import Colors from "@constants/Colors";
import { Box, Typography } from "@mui/material";
import styled from "styled-components";

export const StyledBox = styled(Box)`
  display: flex !important;
  flex-direction: column !important;
  gap: 8px !important;
  padding: 0px !important;
  min-width: 50%;
`;

export const StyledTypographyPct = styled(Typography)`
  width: fit-content !important;
  border-radius: 4px !important;
  font-family: "Ringside Regular-Book" !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 20px !important;
  display: flex !important;
  align-items: center !important;
  color: ${Colors.neutralblack};
`;

export const StyledTypogaphyAct = styled(Typography)`
  display: flex !important;
  align-items: baseline !important;
  font-family: "Ringside Regular-Bold" !important;
  font-weight: 400 !important;
  color: ${Colors.neutralblack};
  font-size: 14px !important;
  line-height: 20px !important;
  overflow-wrap: anywhere !important;
`;
